import { useQuery } from '@tanstack/react-query';
import getTermOffers from '~apis/company/getTermOffers';

const USE_GET_TERM_OFFER_QUERY = {
  root: ['term-offer'],
  default: (companyId: string) => [...USE_GET_TERM_OFFER_QUERY.root, companyId],
};
export default function useTermOfferQuery(companyId?: string) {
  return useQuery(
    USE_GET_TERM_OFFER_QUERY.default(companyId as string),
    () => getTermOffers(companyId as string),
    {
      enabled: !!companyId,
    },
  );
}
